const NUM_DAYS_FOR_WEEK = 7;

export const ONE_DAY_IN_MILLISECONDS = 1000 * 60 * 60 * 24;

export function getDateDifferenceInDays(compareToDate: Date): number {
    return Math.round((new Date().getTime() - compareToDate.getTime()) / ONE_DAY_IN_MILLISECONDS);
}

export function isDateWithinAWeek(currentDate: Date): boolean {
    const dateAWeekAgo = new Date();
    dateAWeekAgo.setDate(dateAWeekAgo.getDate() - NUM_DAYS_FOR_WEEK);

    return currentDate.getTime() > dateAWeekAgo.getTime();
}
